import React from 'react';

const actions = [
  { key: 'transcribe', label: 'Transcribe a video', desc: 'Convert speech in a video to text.' },
  { key: 'create_quiz', label: 'Create a question set', desc: 'Generate questions based on a lesson.' },
  { key: 'summarize', label: 'Generate summary', desc: 'Get key points from your content.' },
];

function ActionCards({ onAction }) {
  return (
    <div className="action-cards">
      {actions.map(a => (
        <div key={a.key} className="action-card" onClick={() => onAction(a.key)}>
          <div className="action-title">{a.label}</div>
          <div className="action-desc">{a.desc}</div>
        </div>
      ))}
    </div>
  );
}

export default ActionCards; 